var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMajesticonsSearchLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 20L15.9499 15.95M15.9499 15.95C16.5999 15.2999 17.1156 14.5282 17.4674 13.6789C17.8192 12.8296 18.0002 11.9193 18.0002 11C18.0002 10.0807 17.8192 9.17039 17.4674 8.32107C17.1156 7.47175 16.5999 6.70003 15.9499 6.04999C15.2998 5.39995 14.5281 4.8843 13.6788 4.5325C12.8295 4.1807 11.9192 3.99963 10.9999 3.99963C10.0806 3.99963 9.17027 4.1807 8.32095 4.5325C7.47163 4.8843 6.69991 5.39995 6.04987 6.04999C4.73705 7.36281 3.99951 9.14338 3.99951 11C3.99951 12.8566 4.73705 14.6372 6.04987 15.95C7.36269 17.2628 9.14326 18.0003 10.9999 18.0003C12.8565 18.0003 14.637 17.2628 15.9499 15.95V15.95Z",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajesticonsSearchLine);
export default __webpack_public_path__ + "static/media/majesticons_search-line.d9ed0502061a057b31994451a83e639e.svg";
export { ForwardRef as ReactComponent };